import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GenericService<T> {
  constructor(
    protected http: HttpClient,
    @Inject(String) protected url: string
  ) {}

  Registrar(entidad: T) {
    return this.http.post<any>(`${this.url}/`, entidad);
  }

  Actualizar(entidad: T)  {
    return this.http.put<any>(`${this.url}/`, entidad);
  }

  ObtenerPorId(id: number){
    return this.http.get<T>(`${this.url}/${id}`);
  }
}